import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Re-export TranslateModule so feature NgModules and standalone components
 * can just import this one module to get the pipe & directive.
 *
 * NOTE:
 * - If your root uses the v17 provider API (provideTranslateService),
 *   TranslateModule has no providers, so plain TranslateModule is correct.
 * - If you use the classic forRoot loader in the root, you may instead use:
 *     imports: [TranslateModule.forChild()],
 *   to avoid re-providing the service.
 */
@NgModule({
    imports: [TranslateModule],
    exports: [TranslateModule],
})
export class TranslatorModule {}
